import { BaseEntity, Entity as DecribeEntity } from '@avangard/utils/entity';

import type { StudentMedical } from '@modules/types/graphql';

export type Entity = Partial<StudentMedical> | null;

type radioBoolean = '0' | '1';

@DecribeEntity('StudentMedicalEntity')
class StudentMedicalEntity extends BaseEntity {
    diets: string;
    proneToColdBool: radioBoolean;
    proneToCold: string;
    fractures: string;
    headInjuries: string;
    allergicDiseases: string;
    allergyMedications: string;
    chronicDiseases: string;
    medications: string;
    heatTransfer: string;
    insectBites: string;
    healthSpecials: string;
    fatigueBool: radioBoolean;
    fatigue: string;
    motionSicknessBool: radioBoolean;
    motionSickness: string;
    wearingGlassesBool: radioBoolean;
    wearingGlasses: string;
    fearDarkBool: radioBoolean;
    fearDark: string;
    otherSpecials: string;

    constructor(entity: Entity) {
        super(entity);

        this.diets = entity?.diets ?? '';
        this.proneToColdBool = this.toRadioBoolean(entity?.proneToColdBool ?? '');
        this.proneToCold = entity?.proneToCold ?? '';
        this.fractures = entity?.fractures ?? '';
        this.headInjuries = entity?.headInjuries ?? '';
        this.allergicDiseases = entity?.allergicDiseases ?? '';
        this.allergyMedications = entity?.allergyMedications ?? '';
        this.chronicDiseases = entity?.chronicDiseases ?? '';
        this.medications = entity?.medications ?? '';
        this.heatTransfer = entity?.heatTransfer ?? '';
        this.insectBites = entity?.insectBites ?? '';
        this.healthSpecials = entity?.healthSpecials ?? '';
        this.fatigueBool = this.toRadioBoolean(entity?.fatigueBool ?? '');
        this.fatigue = entity?.fatigue ?? '';
        this.motionSicknessBool = this.toRadioBoolean(entity?.motionSicknessBool ?? '');
        this.motionSickness = entity?.motionSickness ?? '';
        this.wearingGlassesBool = this.toRadioBoolean(entity?.wearingGlassesBool ?? '');
        this.wearingGlasses = entity?.wearingGlasses ?? '';
        this.fearDarkBool = this.toRadioBoolean(entity?.fearDarkBool ?? '');
        this.fearDark = entity?.fearDark ?? '';
        this.otherSpecials = entity?.otherSpecials ?? '';
    }

    toRadioBoolean(value: string): radioBoolean {
        if (!value || value === '0') {
            return '0';
        }

        return '1';
    }
}

export { StudentMedicalEntity };
